/* Runtime du clone Kalmo — remplace les scripts du concurrent retirés au build.
   Couvre : sélecteur taille/couleur, résolution de variante depuis NOTRE produit,
   cadeau laisse assortie, patch prénom, ajout au panier, barre sticky, carrousels
   Splide, galerie produit. Aucun variant id en dur : tout vient de TC_PRODUCT. */
(function () {
  'use strict';

  var P = window.TC_PRODUCT || null;
  var root = document.querySelector('.tc-clone');
  if (!root) return;

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

  /* ---------- images de la laisse offerte (assets de notre thème) ---------- */
  var LEAD_IMAGES = window.TC_LEAD_IMAGES || {};

  var state = { size: null, colour: null, namePatch: false, nameText: '' };

  /* ================= variantes ================= */

  function variantFor(size, colour) {
    if (!P || !P.variants) return null;
    for (var i = 0; i < P.variants.length; i++) {
      var v = P.variants[i];
      if (String(v.option1) === String(size) && String(v.option2) === String(colour)) return v;
    }
    return null;
  }

  function syncVariantInputs() {
    var v = variantFor(state.size, state.colour);
    if (!v) return null;
    $$('input[name="id"]').forEach(function (i) { i.value = String(v.id); });
    return v;
  }

  /* ================= sélecteurs ================= */

  function initPicker() {
    $$('.pp-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        $$('.pp-size-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        state.size = btn.getAttribute('data-size');
        var l = $('#pp-size-label'); if (l) l.textContent = state.size;
        syncVariantInputs();
        clearError();
      });
    });

    $$('.pp-colour-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        $$('.pp-colour-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        state.colour = btn.getAttribute('data-colour');
        var l = $('#pp-colour-label'); if (l) l.textContent = btn.getAttribute('data-name') || state.colour;
        syncVariantInputs();
        showLeadGift();
        clearError();
      });
    });
  }

  function showLeadGift() {
    var box = $('#pp-free-lead');
    if (!box) return;
    var label = $('#pp-lead-colour');
    var img = $('#pp-lead-image');
    if (label) label.textContent = state.colour || '';
    if (img && LEAD_IMAGES[state.colour]) { img.src = LEAD_IMAGES[state.colour]; img.style.display = ''; }
    if (img && !img.getAttribute('src')) img.style.display = 'none';
    box.classList.add('visible');
  }

  /* ================= patch prénom ================= */

  function initNamePatch() {
    var toggle = $('#pp-name-toggle');
    var wrap = $('#pp-name-input-wrap');
    var input = $('#pp-name-input');
    if (!toggle || !wrap || !input) return;

    toggle.addEventListener('click', function () {
      state.namePatch = !state.namePatch;
      toggle.classList.toggle('active');
      wrap.classList.toggle('visible');
      if (state.namePatch) { setTimeout(function () { input.focus(); }, 250); }
      else { input.value = ''; state.nameText = ''; }
    });
    input.addEventListener('input', function () { state.nameText = input.value.trim(); });
  }

  /* ================= panier ================= */

  function errorSlot() { return $('.main-atc__error'); }

  function clearError() {
    var s = errorSlot();
    if (s) { s.style.display = 'none'; s.textContent = ''; }
  }

  function showError(msg) {
    var s = errorSlot();
    if (s) { s.textContent = msg; s.style.display = 'block'; }
    else { window.alert(msg); }
  }

  function addToCart() {
    if (!P) { showError('Produit indisponible. Rechargez la page.'); return; }
    if (!state.size) { showError('Choisissez une taille.'); return; }
    if (!state.colour) { showError('Choisissez une couleur.'); return; }
    if (state.namePatch && !state.nameText) {
      showError('Indiquez le prénom de votre chien ou décochez le patch personnalisé.');
      return;
    }
    var v = variantFor(state.size, state.colour);
    if (!v) { showError('Cette combinaison est indisponible.'); return; }

    var item = { id: v.id, quantity: 1 };
    if (state.namePatch && state.nameText) {
      item.properties = { 'Patch prénom': state.nameText };
    }

    setLoading(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw new Error(e.description || 'Erreur panier'); }); }
      return r.json();
    }).then(function () {
      return ouvrirTiroir();
    }).catch(function (e) {
      setLoading(false);
      showError(e.message || "L'ajout au panier a échoué. Réessayez.");
    });
  }

  /* ================= tiroir panier =================
     Le defaut du projet : « Ajouter au panier » ouvre le TIROIR, jamais /cart.
     Le clone partait sur /cart — le visiteur quittait la page de vente.
     Deux pieges Dawn, tous les deux payes ailleurs sur ce projet :
       · le tiroir garde la classe `is-empty` tant qu'on ne la retire pas, donc
         il s'ouvre VIDE sur un panier qui vient d'etre rempli ;
       · son HTML doit etre rafraichi (sections API), sinon il montre l'etat
         d'avant l'ajout.
     Si le theme n'a pas de tiroir, on retombe sur /cart : jamais de cul-de-sac. */
  function ouvrirTiroir() {
    var tiroir = document.querySelector('cart-drawer');
    if (!tiroir) { window.location.href = '/cart'; return; }
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var neuf = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html')
                     .querySelector('cart-drawer');
        if (neuf) tiroir.innerHTML = neuf.innerHTML;
        var pastille = document.getElementById('cart-icon-bubble');
        if (pastille && sections['cart-icon-bubble']) {
          var nb = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html')
                     .getElementById('cart-icon-bubble');
          if (nb) pastille.innerHTML = nb.innerHTML;
        }
        tiroir.classList.remove('is-empty');           // sans ca, il s'ouvre vide
        if (typeof tiroir.open === 'function') tiroir.open();
        else tiroir.classList.add('animate', 'active');
        setLoading(false);
      })
      .catch(function () { window.location.href = '/cart'; });
  }

  function setLoading(on) {
    $$('.main-product-atc .loading-overlay__spinner').forEach(function (s) {
      s.classList.toggle('hidden', !on);
    });
  }

  function initCart() {
    // Marqueur convenu du projet : il dit « l'ajout au panier est LIE au tiroir ».
    // `lp-defauts.mjs` le cherche pour distinguer une page qui ouvre le tiroir
    // d'une page qui expedie le client sur /cart. Sans lui, notre implementation
    // est invisible au controle, et la mesure crie sur un defaut qui n'existe pas.
    document.documentElement.dataset.uosDrawerBound = '1';
    $$('form[action*="/cart/add"]').forEach(function (form) {
      form.dataset.uosDrawerBound = '1';
      form.addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); addToCart(); });
    });
    $$('[name="add"], .product-form__submit, .atc-button').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); addToCart(); });
    });
  }

  /* ================= barre sticky ================= */

  function initSticky() {
    var bar = $('sticky-atc');
    if (!bar) return;
    var anchor = $('#pp-picker') || $('.product-form');
    $$('.sticky-atc__scroll-btn', bar).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (state.size && state.colour) { addToCart(); return; }
        if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    var show = function () {
      var y = anchor ? anchor.getBoundingClientRect().bottom : 0;
      bar.classList.toggle('is-visible', y < 0);
      bar.style.transform = y < 0 ? 'translateY(0)' : '';
      bar.style.visibility = y < 0 ? 'visible' : 'hidden';
      bar.style.opacity = y < 0 ? '1' : '0';
    };
    show();
    window.addEventListener('scroll', show, { passive: true });
  }

  /* ================= carrousels Splide ================= */

  function initSplide() {
    $$('.splide__slide--clone').forEach(function (n) { n.remove(); });
    // Splide laisse ses flèches en `disabled` telles qu'elles étaient à la capture :
    // un bouton désactivé n'émet pas de clic, donc « précédent » restait mort.
    $$('.splide__arrow').forEach(function (a) { a.disabled = false; a.removeAttribute('disabled'); });

    $$('.splide').forEach(function (car) {
      var track = car.querySelector('.splide__track');
      var list = car.querySelector('.splide__list');
      if (!track || !list) return;

      list.style.transform = 'none';
      list.style.display = 'flex';
      // sans flex-shrink:0 les slides se compriment pour tenir dans la piste
      // (3 avis écrasés côte à côte sur mobile au lieu d'un carrousel)
      $$('.splide__slide', car).forEach(function (s) { s.style.flexShrink = '0'; });
      track.style.overflowX = 'auto';
      track.style.scrollSnapType = 'x mandatory';
      track.style.scrollBehavior = 'smooth';
      track.style.webkitOverflowScrolling = 'touch';
      track.style.scrollbarWidth = 'none';
      $$('.splide__slide', car).forEach(function (s) { s.style.scrollSnapAlign = 'start'; });

      var step = function () {
        var first = car.querySelector('.splide__slide');
        return first ? first.getBoundingClientRect().width + 16 : track.clientWidth;
      };
      var prev = car.querySelector('.splide__arrow--prev');
      var next = car.querySelector('.splide__arrow--next');
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); track.scrollLeft -= step(); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); track.scrollLeft += step(); });

      var dots = $$('.splide__pagination__page', car);
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          track.scrollLeft = i * step();
          dots.forEach(function (d) { d.classList.remove('is-active'); });
          dot.classList.add('is-active');
        });
      });
      if (dots.length) {
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / step());
          dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
        }, { passive: true });
      }
    });

    responsiveSlides();
    window.addEventListener('resize', responsiveSlides);
  }

  /* Les largeurs de slide sont figées telles que Splide les avait calculées au
     moment de la capture, en desktop (ex. « calc(33.3333% - 26.6667px) »). En
     mobile ça écrase 3 avis côte à côte : on repasse à 1 slide par vue. */
  function responsiveSlides() {
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    $$('.splide__slide').forEach(function (s) {
      var w = s.getAttribute('data-tc-w');
      if (w === null) {
        w = s.style.width || '';
        if (w.indexOf('%') === -1) return;   // pas de largeur figée : on ne touche pas
        s.setAttribute('data-tc-w', w);
      }
      s.style.width = mobile ? '100%' : w;
      if (mobile) s.style.marginRight = '16px';
    });
  }

  /* ================= galerie produit ================= */

  function initGallery() {
    var media = $('.product__media-list');
    if (!media) return;
    media.style.overflowX = 'auto';
    media.style.scrollSnapType = 'x mandatory';
    media.style.scrollBehavior = 'smooth';
    $$('.product__media-item', media).forEach(function (li) { li.style.scrollSnapAlign = 'start'; });

    $$('.thumbnail-list__item').forEach(function (li, i) {
      li.addEventListener('click', function (e) {
        e.preventDefault();
        var target = $$('.product__media-item', media)[i];
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        $$('.thumbnail-list__item').forEach(function (t) { t.classList.remove('is-active'); });
        li.classList.add('is-active');
      });
    });
  }

  /* ================= guide des tailles ================= */

  function initSizeGuide() {
    var modal = $('#pp-size-modal');
    var overlay = $('#pp-size-modal-overlay');
    var trigger = $('#pp-size-guide-trigger');
    if (!modal || !overlay) return;

    function open(e) {
      if (e) e.preventDefault();
      modal.classList.add('visible');
      overlay.classList.add('visible');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('visible');
      overlay.classList.remove('visible');
      document.documentElement.style.overflow = '';
    }

    if (trigger) trigger.addEventListener('click', open);
    // le concurrent ouvre aussi depuis tout lien « Guide des tailles »
    $$('.pp-size-guide-trigger').forEach(function (t) { t.addEventListener('click', open); });
    var closeBtn = $('#pp-size-modal-close');
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ================= zoom galerie (lightbox) ================= */

  /* Le <product-modal> de Dawn part au build (custom element sans son JS) : on
     reconstruit la visionneuse à partir des images de la galerie elle-même. */
  function initLightbox() {
    var openers = $$('.product__modal-opener');
    if (!openers.length) return;

    var box = document.createElement('div');
    box.className = 'tc-lightbox';
    box.innerHTML =
      '<button class="tc-lightbox__close" type="button" aria-label="Fermer">&times;</button>' +
      '<button class="tc-lightbox__nav tc-lightbox__nav--prev" type="button" aria-label="Image précédente">&#8249;</button>' +
      '<button class="tc-lightbox__nav tc-lightbox__nav--next" type="button" aria-label="Image suivante">&#8250;</button>' +
      '<div class="tc-lightbox__stage"></div>' +
      '<div class="tc-lightbox__count"></div>';
    root.appendChild(box);

    // l'image n'est créée qu'à l'ouverture : un <img src=""> compte comme image cassée
    var stage = box.querySelector('.tc-lightbox__stage');
    var stageImg = null;
    var counter = box.querySelector('.tc-lightbox__count');
    var sources = [];
    var index = 0;

    function collect() {
      sources = $$('.product__media-item img').map(function (img) {
        return { src: img.currentSrc || img.src, alt: img.getAttribute('alt') || '' };
      }).filter(function (s) { return s.src; });
    }

    function show(i) {
      if (!sources.length) return;
      if (!stageImg) { stageImg = document.createElement('img'); stage.appendChild(stageImg); }
      index = (i + sources.length) % sources.length;
      stageImg.src = sources[index].src;
      stageImg.alt = sources[index].alt;
      counter.textContent = (index + 1) + ' / ' + sources.length;
    }

    function open(i) {
      collect();
      show(i);
      box.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      box.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    openers.forEach(function (op) {
      op.addEventListener('click', function (e) {
        e.preventDefault();
        var item = op.closest('.product__media-item');
        var all = $$('.product__media-item');
        open(Math.max(0, all.indexOf(item)));
      });
    });

    box.querySelector('.tc-lightbox__close').addEventListener('click', close);
    box.querySelector('.tc-lightbox__nav--prev').addEventListener('click', function () { show(index - 1); });
    box.querySelector('.tc-lightbox__nav--next').addEventListener('click', function () { show(index + 1); });
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') show(index + 1);
      if (e.key === 'ArrowLeft') show(index - 1);
    });
  }

  /* ================= images lazy sans lazysizes ================= */

  function initLazy() {
    $$('img[data-src]').forEach(function (img) {
      if (!img.getAttribute('src')) img.src = img.getAttribute('data-src');
      img.classList.add('lazyloaded');
    });
    // Un src="" est une requête cassée (le navigateur recharge la page courante) :
    // on retire l'attribut tant qu'il n'y a rien à afficher — ex. le visuel de la
    // laisse offerte, qui n'a de source qu'une fois la couleur choisie.
    $$('img[src=""]').forEach(function (img) {
      img.removeAttribute('src');
      img.style.display = 'none';
    });
    // Le lazy-load du concurrent gardait la source dans `h-data-src` : sans son
    // script, la 2e vidéo n'avait aucun `src` et restait un cadre vide.
    $$('video').forEach(function (v) {
      var changed = false;
      $$('source', v).forEach(function (s) {
        var lazy = s.getAttribute('h-data-src') || s.getAttribute('data-src');
        if (lazy && !s.getAttribute('src')) { s.setAttribute('src', lazy); changed = true; }
      });
      // un .mp4 en poster n'affiche rien : on laisse la première image faire office d'aperçu
      var poster = v.getAttribute('poster') || '';
      if (/\.(mp4|mov|webm)(\?|$)/i.test(poster)) v.removeAttribute('poster');
      v.setAttribute('playsinline', '');
      v.muted = true;
      if (changed) v.load();
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  function boot() {
    initLazy();
    initPicker();
    initNamePatch();
    initCart();
    initSticky();
    initSplide();
    initGallery();
    initSizeGuide();
    initLightbox();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
